import moment from "moment";

export const APP_TIME_ZONE = "Asia/Kolkata";
export const APP_UTC_OFFSET_MINUTES = 330;

const getTimeZonePart = (date, type) => {
  const part = new Intl.DateTimeFormat("en-GB", {
    timeZone: APP_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .find(item => item.type === type);

  return part?.value || "";
};

export const getAppDateString = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  const year = getTimeZonePart(date, "year");
  const month = getTimeZonePart(date, "month");
  const day = getTimeZonePart(date, "day");
  return `${year}-${month}-${day}`;
};

export const getAppTimeString = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  const hour = getTimeZonePart(date, "hour");
  const minute = getTimeZonePart(date, "minute");
  return `${hour}:${minute}`;
};

export const getAppDateTimeString = (value = new Date()) => (
  `${getAppDateString(value)} ${getAppTimeString(value)}:${String(
    (value instanceof Date ? value : new Date(value)).getSeconds()
  ).padStart(2, "0")}`
);

export const addDaysToDateString = (dateString, days) => {
  const [year, month, day] = String(dateString).split("-").map(Number);
  if (!year || !month || !day) return getAppDateString();

  const date = new Date(Date.UTC(year, month - 1, day + days, 12, 0, 0));
  return getAppDateString(date);
};

/**
 * For CSV / stored-as-local times (ordered_on, uploaded_at).
 */
export const formatLocalDateTime = (value) => {
  if (!value) return "N/A";
  const text = String(value);
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
  const parsed = hasZone
    ? moment.parseZone(text, moment.ISO_8601, true).utcOffset(APP_UTC_OFFSET_MINUTES)
    : moment(text, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", moment.ISO_8601], true);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY HH:mm") : "N/A";
};

/**
 * For scanned_on. Backend stores app-local Asia/Kolkata wall time.
 */
export const formatServerDateTime = (value) => {
  if (!value) return "N/A";
  return formatLocalDateTime(value);
};

export const formatScanTime = (value) => {
  if (!value) return "Unknown Time";

  const text = String(value);
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
  const parsedServer = hasZone
    ? moment.parseZone(text, moment.ISO_8601, true).utcOffset(APP_UTC_OFFSET_MINUTES)
    : moment(text, [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss"], true);
  if (parsedServer.isValid()) {
    return parsedServer.format("HH:mm:ss");
  }

  const parsedLocal = moment(value, ["M/D/YYYY, h:mm:ss A", "D/M/YYYY, h:mm:ss A"], true);
  return parsedLocal.isValid() ? parsedLocal.format("HH:mm:ss") : "Unknown Time";
};

export const formatDate = (value) => {
  if (!value) return "";
  const text = String(value);
  const hasZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
  const parsed = hasZone
    ? moment.parseZone(text, moment.ISO_8601, true).utcOffset(APP_UTC_OFFSET_MINUTES)
    : moment(text, [moment.ISO_8601, "YYYY-MM-DD"], true);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "";
};
